



import Page from '../RMA/RMAOrder.vue'
export default {
  name: 'rmaOrderRD',
  components: { Page },
}
